import axiosApi, { setHeader } from "api/root.api";

export const checkNoPermission = async (token) => {
  const urlEnd = "/platform/product/v1/noPermission";
  setHeader("Authorization", `Bearer ${token}`);
  const response = await axiosApi.get(urlEnd);
  const result = response.data.code;
  return result;
};
